/**
 * Lock-expiry client (DEV-3636, Skynet.Loans behind the loans gateway).
 * GET /api/lockExpiry/expiring returns locks expiring within the requested
 * window (max 60 days), server-scoped from the authenticated user. Display-only;
 * extension cost stays in Pricing.
 *
 * Response shape:
 *   { locks: [{ applicationId, borrowerLastName, loanNumberLast4,
 *               lockExpirationDate, lockTermDays }], windowDays, asOf }
 */
export class LockExpiryApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getExpiringLocks({ withinDays, config = {} } = {}) {
    return this.#http.get('/api/lockExpiry/expiring', { ...config, params: { withinDays } });
  }
}
